import { RestClient } from '@/api/rest-client'
import { cloneDeep } from 'lodash'
import { PipelineConnection } from '@/api/model/pipeline-connection'
import { Company } from '@/api/model/company'
import { Pipeline } from '@/api/model/pipeline'
import { CompanyAPI } from '@/api/backend-client'

export class PipelineConnectionClient extends RestClient<PipelineConnection> {
    collectionName = 'pipeline_connections'
    parseData = PipelineConnection.fromData
    convertData = (data: PipelineConnection) => {
        const request = cloneDeep<any>(data)

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        if (data.sourceCompany instanceof Company) {
            request.sourceCompany = data.sourceCompany.resourceIdentifier
        }

        if (data.targetCompany instanceof Company) {
            request.targetCompany = data.targetCompany.resourceIdentifier
        }

        return request
    }

    // A link changed: the companies in CompanyAPI's cache may show more or less now
    async create(data: PipelineConnection): Promise<PipelineConnection> {
        const connection = await super.create(this.convertData(data))
        CompanyAPI.forgetRelatedCompanies()

        return connection
    }

    async update(id: string, data: PipelineConnection): Promise<PipelineConnection> {
        const connection = await super.update(id, this.convertData(data))
        CompanyAPI.forgetRelatedCompanies()

        return connection
    }

    async delete(id: string): Promise<void> {
        await super.delete(id)
        CompanyAPI.forgetRelatedCompanies()
    }
}
